import { Injectable } from '@angular/core';
import { getStorageObjectUrl, supabase } from '../../core/supabase/supabase.client';
export interface OperationalAlert {
  id: number; store_id: number; alert_type: string; entity_type: string; entity_id: string;
  status: string; created_at: string; details: { stage_since?: string; order_id?: number; order_number?: string };
}
export interface OperationalRule { store_id: number; unaccepted_minutes: number; packing_minutes: number; ready_minutes: number; delivery_minutes: number; }
export interface OperationalWorkspace { rows: OperationalAlert[]; total: number; synced_at: string; rules: OperationalRule[]; }
export interface FinanceRow { id: number; order_number: string; expected: number; handed_over: number; discrepancy: number; collection_status: string; }
export interface FinanceReconciliation {
  online_captured: number; refunds_processed: number; manual_external_refunds: number; net_online_cash_movement: number;
  cod_expected: number; cod_collection_confirmed: number; cod_handed_over: number; cod_discrepancy: number;
  cash_handovers_recorded_today: number; wallet_adjustments: number; captures_missing_paid_at: number;
  settlement_status: string; status: string; rows: FinanceRow[]; total: number;
}
@Injectable({ providedIn: 'root' })
export class OperationsService {
  fileUrl(bucket: string, path: string) { return getStorageObjectUrl(bucket, path); }
  async call<T>(name: string, args: Record<string, unknown>): Promise<T> {
    const { data, error } = await supabase.rpc(name, args);
    if (error) throw new Error(error.message);
    return data as T;
  }
  workspace(store: number | null, offset = 0) {
    return this.call<OperationalWorkspace>('admin_operational_workspace', { p_store_id: store, p_offset: offset });
  }
  acknowledge(id: number) { return this.call('admin_acknowledge_operational_alert', { p_id: id }); }
  saveRules(rule: OperationalRule) { return this.call('admin_save_operational_rules', { p_store_id: rule.store_id, p_rules: rule }); }
  finance(store: number | null, date: string, offset = 0) {
    return this.call<FinanceReconciliation>('admin_finance_reconciliation', { p_store_id: store, p_date: date, p_offset: offset });
  }
}
